// Module
var code = "<md-input-container class=\"md-block\" flex>\n    <label>{{'EQUIPMENT.TABS.FORM.SERIAL_NUMBER' | translate}}</label>\n    <input ng-model=\"$ctrl.serial\" ng-change=\"$ctrl.onChange()\">\n</md-input-container>\n";
// Exports
module.exports = code;